<template>
  <article class="article">
    <div class="article__content">
      <border-box>
        <h2 class="article__heading"><span v-html="heading"/></h2>
        <p class="article__p"><span v-html="description"/></p>
      </border-box>
    </div>
    <div class="article__footer">
      <arrow-link :href="link">info</arrow-link>
      <photo :src="photo" :url="link"/>
    </div>
  </article>
</template>

<script>
import BorderBox from '@/components/BorderBox'
import Photo from '@/components/Photo'
import ArrowLink from '@/components/ArrowLink'

export default {
  components: {
    BorderBox,
    Photo,
    ArrowLink
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    photo: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .article {
    @include equal-height-column;

    &__heading {
      @include vertical-space((bottom: 1), padding);
      @include text(big, bold)
    }

    &__footer {
      @include vertical-space((top: 1), padding);
    }

    &__p {
      @include text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Article.vue